import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-grey-3 pb-4" }
const _hoisted_2 = { class: "mb-5" }
const _hoisted_3 = { class: "flex mb-1 justify-center" }
const _hoisted_4 = { class: "w-48 text-right mr-10" }
const _hoisted_5 = { class: "w-104 text-left" }
const _hoisted_6 = { class: "flex mb-1 justify-center" }
const _hoisted_7 = { class: "w-48 text-right mr-10" }
const _hoisted_8 = { class: "w-104 flex text-left" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", null, "～", -1)
const _hoisted_10 = { class: "flex justify-center" }
const _hoisted_11 = { class: "w-48 text-right mr-10" }
const _hoisted_12 = { class: "w-104 text-left" }
const _hoisted_13 = { class: "content m-auto" }
const _hoisted_14 = { class: "mb-8 w-2/3 m-auto" }
const _hoisted_15 = { class: "ml-4 mb-1 font-bold" }
const _hoisted_16 = { class: "font-size-18 mr-8" }
const _hoisted_17 = { class: "text-2xl" }
const _hoisted_18 = { class: "text-2xl" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "mb-4 w-2/3 m-auto" }
const _hoisted_21 = { class: "flex mb-1 justify-between" }
const _hoisted_22 = { class: "ml-4 font-bold" }
const _hoisted_23 = { class: "font-size-18 mr-8" }
const _hoisted_24 = { class: "text-2xl" }
const _hoisted_25 = { class: "text-2xl" }
const _hoisted_26 = { class: "ml-1" }
const _hoisted_27 = { class: "flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Table = _resolveComponent("Table")
  const _component_Popup = _resolveComponent("Popup")

  return (_openBlock(), _createBlock(_component_Popup, {
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShow = $event)),
    width: "1086px",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('departmentToBeShifted')), 1),
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.requestToSubmittedInfo.department_to_be_shifted), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('applicationSubmit')), 1),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", null, _toDisplayString(_ctx.requestToSubmittedInfo.application_submit.start), 1),
              _hoisted_9,
              _createVNode("div", null, _toDisplayString(_ctx.requestToSubmittedInfo.application_submit.end), 1)
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.t('submissionDeadline')), 1),
            _createVNode("div", _hoisted_12, _toDisplayString(_ctx.requestToSubmittedInfo.submission_deadline), 1)
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.t('unSubmittedMembers')), 1),
              _createVNode("span", _hoisted_17, _toDisplayString(_ctx.personToSubmittedData.length), 1),
              _createVNode("span", _hoisted_18, _toDisplayString(_ctx.t('person')), 1)
            ]),
            _createVNode(_component_Table, {
              class: "h-64 text-center",
              headers: _ctx.membersToSubmittedHeaders,
              data: _ctx.personToSubmittedData,
              "fixed-header": "",
              "show-select": "",
              "selected-item": _ctx.personSelected,
              "onUpdate:selected-item": _cache[1] || (_cache[1] = ($event: any) => (_ctx.personSelected = $event))
            }, {
              name: _withCtx(({ item }) => [
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_Avatar, {
                    width: "40px",
                    height: "40px",
                    src: item.avatar,
                    class: "mr-2"
                  }, null, 8, ["src"]),
                  _createVNode("div", null, _toDisplayString(item.name), 1)
                ])
              ]),
              _: 1
            }, 8, ["headers", "data", "selected-item"])
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode("span", _hoisted_23, _toDisplayString(_ctx.t('submittedMembers')), 1),
                _createVNode("span", _hoisted_24, _toDisplayString(_ctx.personToUnSubmittedData.length), 1),
                _createVNode("span", _hoisted_25, _toDisplayString(_ctx.t('person')), 1)
              ]),
              _createVNode("div", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPromptToSendRequest && _ctx.onPromptToSendRequest(...args))),
                class: "cursor-pointer items-center text-light-blue flex font-bold hover:opacity-75"
              }, [
                _createVNode("span", null, [
                  _createVNode("img", {
                    src: _ctx.iconSend,
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _createVNode("span", _hoisted_26, _toDisplayString(_ctx.t('promptToSendRequest')), 1)
              ])
            ]),
            _createVNode(_component_Table, {
              class: "h-64 text-center",
              headers: _ctx.membersToSubmittedHeaders,
              data: _ctx.personToUnSubmittedData,
              "fixed-header": "",
              "show-select": "",
              "selected-item": _ctx.personSelected,
              "onUpdate:selected-item": _cache[3] || (_cache[3] = ($event: any) => (_ctx.personSelected = $event))
            }, {
              name: _withCtx(({ item }) => [
                _createVNode("div", _hoisted_27, [
                  _createVNode(_component_Avatar, {
                    width: "40px",
                    height: "40px",
                    src: item.avatar,
                    class: "mr-2"
                  }, null, 8, ["src"]),
                  _createVNode("div", null, _toDisplayString(item.name), 1)
                ])
              ]),
              _: 1
            }, 8, ["headers", "data", "selected-item"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}